import React from 'react';
import ContactForm from '../ContactFrom/ContactForm'
import styles from './ContactPage.module.css'


const Contactpage = () => {
     return (
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        {/* Phần giới thiệu về dự án của các em */}
                        <div className="wpo-contact-title" style={{ textAlign: 'center', marginBottom: '40px' }}>
                            <h2>Về Dự Án CaoBangCeritage Của Chúng Em</h2>
                            <p>Chúng em là nhóm học sinh yêu thích khám phá văn hóa Việt Nam. Dự án này là hành trình chúng em tìm hiểu về vẻ đẹp độc đáo của các loại vải truyền thống dân tộc. Chúng em rất vui nếu nhận được sự quan tâm, chia sẻ kiến thức và những lời động viên từ cộng đồng!</p>
                            {/* Optional: Thêm ảnh dự án
                            {projectImage && <img src={projectImage} alt="Dự án của chúng em" style={{maxWidth: '80%', marginTop: '20px', borderRadius: '8px'}}/>}
                             */}
                        </div>

                        {/* Thông tin liên hệ và Kêu gọi đóng góp */}
                        <div className="office-info">
                            <div className="row">
                                {/* Mục 1: Email Liên Hệ */}
                                <div className={`col col-xl-6 col-lg-6 col-md-6 col-12`} >
                                    <div className={`office-info-item ${styles.serviceCardWrapper}`}>
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Gửi thư cho chúng em</h2>
                                            <p>Mọi góp ý, chia sẻ xin gửi về hòm thư:</p>
                                            {/* Thay bằng email thực tế của dự án */}
                                            <p><strong>caobangceritage@gmail.com</strong></p>
                                        </div>
                                    </div>
                                </div>
                                {/* Mục 2: Kêu gọi ủng hộ */}
                                <div className="col col-xl-6 col-lg-6 col-md-6 col-12">
                                    <div className={`office-info-item ${styles.serviceCardWrapper}`}>
                                        <div className="office-info-icon">
                                            {/* Có thể đổi icon khác phù hợp hơn, ví dụ trái tim hoặc bàn tay*/}
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Ủng hộ dự án</h2>
                                            <p>Để dự án nhỏ của chúng em được tiếp tục, rất mong nhận được sự quan tâm và đóng góp từ mọi người.</p>
                                            {/* Có thể thêm link tới trang/thông tin ủng hộ nếu có */}
                                            {/* <p><a href="/ung-ho">Tìm hiểu thêm cách ủng hộ</a></p> */}
                                        </div>
                                    </div>
                                </div>
                                {/* Có thể bỏ mục Địa chỉ và Số điện thoại hoặc thay bằng thông tin trường/người hướng dẫn nếu phù hợp và được phép */}
                            </div>
                        </div>

                        {/* Form liên hệ */}
                        <div className="wpo-contact-title">
                             {/* Có thể đổi tiêu đề phù hợp hơn */}
                            <h2>Gửi Lời Nhắn Cho Chúng Em</h2>
                            <p>Nếu có câu hỏi hay muốn chia sẻ điều gì, đừng ngần ngại gửi tin nhắn cho nhóm chúng em nhé!</p>
                        </div>
                        <div className="wpo-contact-form-area">
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-contact-map" style={{position: "relative",height: "50vh", width: "99vw", alignItems: "center", margin: "50px auto 0"}}>
                {/* <iframe title='comtact-map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.9147703055!2d-74.11976314309273!3d40.69740344223377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew+York%2C+NY%2C+USA!5e0!3m2!1sen!2sbd!4v1547528325671"></iframe> */}
                <iframe title='comtact-map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59587.97642209973!2d105.8369637!3d21.022739599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ab9bd9861ca1%3A0xe7887f7b72ca17a9!2sHanoi%2C%20Vietnam!5e0!3m2!1sen!2sus!4v1744327222978!5m2!1sen!2sus" style={{width: "100%", height: "100%"}}></iframe>
            </div>
        </section>
    )

        
}

export default Contactpage;
